import React from "react";
import PropTypes from "prop-types";

import DragIcon from "./DragIcon";

import useStyles from "./node-content-renderer-style";

function isDescendant(older, younger) {
    return (
        !!older.children &&
        typeof older.children !== "function" &&
        older.children.some((child) => child === younger || isDescendant(child, younger))
    );
}

function FileThemeNodeContentRenderer(props) {
    const {
        connectDragPreview,
        connectDragSource,
        isDragging,
        canDrop,
        canDrag,
        node,
        title,
        draggedNode,
        path,
        treeIndex,
        isSearchMatch,
        isSearchFocus,
        icons,
        buttons,
        className,
        style,
        didDrop,
        // treeId // Not needed, but preserved for other renderers
        // isOver, // Not needed, but preserved for other renderers
        // parentNode, // Needed for dndManager
        // rowDirection
    } = props;

    const classes = useStyles();

    const nodeTitle = title || node.title;

    const isDraggedDescendant = draggedNode && isDescendant(draggedNode, node);
    const isLandingPadActive = !didDrop && isDragging;

    const nodeContent = (
        <div
            className={classes.nodeContent}
            style={{
                display: "flex",
                alignItems: "center",
                height: "100%",
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
            }}
        >
            <div
                className={
                    classes.rowWrapper + (!canDrag ? ` ${classes.rowWrapperDragDisabled}` : "")
                }
                style={{ flex: 1, minWidth: 0, maxWidth: "100%", overflow: "hidden" }}
            >
                {connectDragPreview(
                    <div
                        className={
                            classes.row +
                            (isLandingPadActive ? ` ${classes.rowLandingPad}` : "") +
                            (isLandingPadActive && !canDrop ? ` ${classes.rowCancelPad}` : "") +
                            (isSearchMatch && !isSearchFocus ? ` ${classes.rowSearchMatch}` : "") +
                            (isSearchFocus ? ` ${classes.rowSearchFocus}` : "") +
                            (className ? ` ${className}` : "")
                        }
                        style={{
                            opacity: isDraggedDescendant ? 0.5 : 1,
                            flex: 1,
                            minWidth: 0,
                            maxWidth: "100%",
                            overflow: "hidden",
                            ...style,
                        }}
                    >
                        <div
                            className={
                                classes.rowContents +
                                (!canDrag ? ` ${classes.rowContentsDragDisabled}` : "")
                            }
                            style={{ flex: 1, minWidth: 0, maxWidth: "100%", overflow: "hidden" }}
                        >
                            {connectDragSource(
                                <div>
                                    <DragIcon />
                                </div>,
                            )}
                            <div className={classes.rowIcon}>{icons}</div>
                            <div
                                className={classes.rowLabel}
                                style={{ flex: 1, minWidth: 0, overflow: "hidden" }}
                            >
                                {typeof nodeTitle === "string" ? (
                                    <span className={classes.rowTitle}>{nodeTitle}</span>
                                ) : typeof nodeTitle === "function" ? (
                                    nodeTitle({
                                        node,
                                        path,
                                        treeIndex,
                                    })
                                ) : (
                                    nodeTitle
                                )}
                            </div>
                            <div className={classes.rowToolbar}>{buttons}</div>
                        </div>
                    </div>,
                )}
            </div>
        </div>
    );

    // return canDrag ?
    //   connectDragSource(nodeContent, { dropEffect: 'copy' }) :
    //   nodeContent

    return nodeContent;
}

FileThemeNodeContentRenderer.defaultProps = {
    buttons: null,
    canDrag: false,
    canDrop: false,
    className: "",
    draggedNode: null,
    icons: null,
    isSearchFocus: false,
    isSearchMatch: false,
    parentNode: null,
    style: {},
    swapDepth: null,
    swapFrom: null,
    swapLength: null,
    title: null,
    toggleChildrenVisibility: null,
};

FileThemeNodeContentRenderer.propTypes = {
    buttons: PropTypes.node,
    canDrag: PropTypes.bool,
    canDrop: PropTypes.bool,
    className: PropTypes.string,
    connectDragPreview: PropTypes.func.isRequired,
    connectDragSource: PropTypes.func.isRequired,
    didDrop: PropTypes.bool.isRequired,
    draggedNode: PropTypes.shape({}),
    icons: PropTypes.node,
    isDragging: PropTypes.bool.isRequired,
    isOver: PropTypes.bool.isRequired,
    isSearchFocus: PropTypes.bool,
    isSearchMatch: PropTypes.bool,
    listIndex: PropTypes.number.isRequired,
    lowerSiblingCounts: PropTypes.arrayOf(PropTypes.number).isRequired,
    node: PropTypes.shape({}).isRequired,
    parentNode: PropTypes.shape({}),
    path: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
    rowDirection: PropTypes.string.isRequired,
    scaffoldBlockPxWidth: PropTypes.number.isRequired,

    // Drag and drop API functions
    // Drag source
    style: PropTypes.shape({}),
    swapDepth: PropTypes.number,
    swapFrom: PropTypes.number,
    swapLength: PropTypes.number,
    title: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    toggleChildrenVisibility: PropTypes.func, // Needed for dndManager
    // Drop target
    treeId: PropTypes.string.isRequired,
    treeIndex: PropTypes.number.isRequired,
};

export default FileThemeNodeContentRenderer;
